export enum ProjectType {
  DAY_TO_DAY = 'day_to_day',
  PROJECT = 'project',
}
